<template>
  <div class="orderGoods">
    <div class="total">1 Item</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper" v-if="evaluate">
        <div class="pictrue">
          <img :src="cartInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cartInfo.name }}</div>
            <div class="num">x 1</div>
          </div>

          <!--<div class="money font-color-red" >{{ cartInfo.integral }}积分</div>-->
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "IntegralOrderGoods",
    props: {
      evaluate: String,
      cartInfo: {
        type: Object,
        default: () => {

        }
      },

    },
    data: function () {
      return {};
    },
    mounted: function () { },
    methods: {}
  };
</script>